import { AbstractTile } from "@/components/design/AbstractTile";

type TileVariant = "dots" | "lines" | "grid" | "rings" | "block" | "plain";

// Artwork surface for a Grow catalogue tile and for the header of a group
// overview. Editorial artwork is shown sharp and format-filling - an editor who
// uploads a motif has to recognise it - so this is deliberately not the blurred
// ambient treatment the tiles used to carry. genesis serves the `card` variant at
// max height 140 and it is upscaled here, which is the same quality trade /share
// already makes; flat motifs work, fine detail and text in the image do not.
//
// Without artwork it falls back to the AbstractTile. The hue is the caller's job:
// it is derived from the group id so a group keeps its colour across loads.
// For SAM artwork, sharpness tracks answered statements in the same four
// blur/scale steps used by PowerTile. Questionnaire artwork stays sharp.
const PROGRESS_BLUR = ["blur-md", "blur-[6px]", "blur-[3px]", "blur-none"] as const;
const PROGRESS_SCALE = ["scale-110", "scale-110", "scale-105", "scale-100"] as const;

function progressSharpness({ answered, total }: { answered: number; total: number }) {
  if (total <= 0 || answered <= 0) return 0;
  if (answered >= total) return 3;
  return answered / total < 0.5 ? 1 : 2;
}

export function TileArtwork({
  imageSrc,
  hue,
  variant,
  className,
  imageProgress,
}: {
  imageSrc?: string;
  hue: number;
  variant: TileVariant;
  className?: string;
  imageProgress?: { answered: number; total: number };
}) {
  if (!imageSrc) {
    return <AbstractTile variant={variant} hue={hue} className={className} />;
  }
  const sharpness = imageProgress ? progressSharpness(imageProgress) : null;
  return (
    <div className={`relative overflow-hidden ${className ?? ""}`}>
      <img
        src={imageSrc}
        alt=""
        className={`absolute inset-0 h-full w-full object-cover ${sharpness === null ? "" : `${PROGRESS_BLUR[sharpness]} ${PROGRESS_SCALE[sharpness]} transition-[filter,transform] duration-300`}`}
      />
    </div>
  );
}
